var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
      _c("h3", { staticClass: "text-themecolor" }, [
        _vm._v(_vm._s(_vm.trans("user.user")) + " \n            "),
        _vm.user.profile
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(
                  _vm.user.profile.first_name + " " + _vm.user.profile.last_name
                ) +
                  " (" +
                  _vm._s(_vm.user.email) +
                  ")"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/users/general-partners")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v("General Partners"),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "col-12 col-sm-8" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body p-4" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("user-sidebar", {
                        attrs: { menu: "notes", id: _vm.id },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-9 col-sm-9 pta-content-notes" },
                        [
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v("Notes\n                                  "),
                            !_vm.showCreatePanel &&
                            _vm.hasPermission("create-user")
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-info btn-sm pull-right m-r-10",
                                    on: {
                                      click: function ($event) {
                                        _vm.showCreatePanel =
                                          !_vm.showCreatePanel
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-plus" }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "d-none d-sm-inline" },
                                      [_vm._v("Add Note")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm.hasPermission("create-user")
                            ? _c("transition", { attrs: { name: "fade" } }, [
                                _vm.showCreatePanel
                                  ? _c(
                                      "div",
                                      { staticClass: "card border-bottom" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "card-body p-4",
                                            staticStyle: {
                                              background: "#efefef",
                                            },
                                          },
                                          [
                                            _c(
                                              "form",
                                              {
                                                attrs: { autocomplete: "off" },
                                                on: {
                                                  submit: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.submit.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                  keydown: function ($event) {
                                                    return _vm.userNoteForm.errors.clear(
                                                      $event.target.name
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-12 col-sm-12",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-12",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "form-group",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "label",
                                                                      {
                                                                        attrs: {
                                                                          for: "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Note"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "autosize-textarea",
                                                                      {
                                                                        attrs: {
                                                                          placeholder:
                                                                            "",
                                                                          rows: "2",
                                                                          name: "text",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .userNoteForm
                                                                              .text,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.userNoteForm,
                                                                                "text",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "userNoteForm.text",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "show-error",
                                                                      {
                                                                        attrs: {
                                                                          "form-name":
                                                                            _vm.userNoteForm,
                                                                          "prop-name":
                                                                            "text",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-info waves-effect waves-light pull-right",
                                                    attrs: { type: "submit" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans("general.add")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger waves-effect waves-light pull-right m-r-10",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.showCreatePanel =
                                                          !_vm.showCreatePanel
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "general.cancel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user_notes.total
                            ? _c("div", { staticClass: "card" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body",
                                    staticStyle: { padding: "0" },
                                  },
                                  [
                                    _vm.hasPermission("list-user") &&
                                    _vm.user_notes.total
                                      ? _c(
                                          "div",
                                          { staticClass: "table-responsive" },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table table-hover",
                                              },
                                              [
                                                _c("thead", [
                                                  _c("tr", [
                                                    !_vm.note.pd_id
                                                      ? _c(
                                                          "th",
                                                          {
                                                            attrs: {
                                                              scope: "col",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.trans(
                                                                  "note.text"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("th", {
                                                      staticClass:
                                                        "table-option",
                                                      attrs: { scope: "col" },
                                                    }),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.user_notes.data,
                                                    function (note) {
                                                      return _c("tr", [
                                                        !note.pd_id
                                                          ? _c("td", [
                                                              note.creator_user
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          "margin-bottom":
                                                                            "5px",
                                                                          "font-size":
                                                                            "12px",
                                                                          "line-height":
                                                                            "18px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "created by " +
                                                                          _vm._s(
                                                                            note
                                                                              .creator_user
                                                                              .profile
                                                                              .first_name
                                                                          ) +
                                                                          " on " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "moment"
                                                                            )(
                                                                              note.created_at
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              !note.creator_user
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          "margin-bottom":
                                                                            "5px",
                                                                          "font-size":
                                                                            "12px",
                                                                          "line-height":
                                                                            "18px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "created by " +
                                                                          _vm._s(
                                                                            note.creator_user_name
                                                                          ) +
                                                                          " on " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "moment"
                                                                            )(
                                                                              note.created_at
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.convertNl2Br(
                                                                        note.text
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        note.pd_id
                                                          ? _c("td", [
                                                              note.creator_user
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          "margin-bottom":
                                                                            "5px",
                                                                          "font-size":
                                                                            "12px",
                                                                          "line-height":
                                                                            "18px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "created by " +
                                                                          _vm._s(
                                                                            note
                                                                              .creator_user
                                                                              .profile
                                                                              .first_name
                                                                          ) +
                                                                          " on " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "moment"
                                                                            )(
                                                                              note.created_at
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              !note.creator_user
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "block",
                                                                          "margin-bottom":
                                                                            "5px",
                                                                          "font-size":
                                                                            "12px",
                                                                          "line-height":
                                                                            "18px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "created by " +
                                                                          _vm._s(
                                                                            note.creator_user_name
                                                                          ) +
                                                                          " on " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "moment"
                                                                            )(
                                                                              note.created_at
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      note.text
                                                                    ),
                                                                },
                                                              }),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-option",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "btn-group",
                                                              },
                                                              [
                                                                _vm.hasPermission(
                                                                  "delete-user"
                                                                )
                                                                  ? _c(
                                                                      "button",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "confirm",
                                                                              rawName:
                                                                                "v-confirm",
                                                                              value:
                                                                                {
                                                                                  ok: _vm.confirmDelete(
                                                                                    note
                                                                                  ),
                                                                                },
                                                                              expression:
                                                                                "{ok: confirmDelete(note)}",
                                                                            },
                                                                            {
                                                                              name: "tooltip",
                                                                              rawName:
                                                                                "v-tooltip",
                                                                              value:
                                                                                "Remove note",
                                                                              expression:
                                                                                "'Remove note'",
                                                                            },
                                                                          ],
                                                                        key: note.id,
                                                                        staticClass:
                                                                          "btn btn-danger btn-sm",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fas fa-trash",
                                                                          }
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ])
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ])
                            : _c("div", [_vm._v("No notes available.")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("user-summary", { attrs: { user: _vm.user } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }